import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { RateCalculator } from '@/components/RateCalculator';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

export default function RateCalculatorPage() {
  return (
    <div className="min-h-screen bg-[#0A0E1A]">
      <Navbar />
      
      <section className="py-20 px-6" data-testid="rate-calculator-page">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold tracking-tighter uppercase mb-4 text-center">
            <span className="text-white">RATE </span>
            <span className="text-[#00A6E8]">CALCULATOR</span>
          </h1>
          <p className="text-slate-400 text-center mb-12">Estimate your logistics costs with our transparent rate calculator</p>
          
          <RateCalculator />
          
          <div className="mt-12 text-center">
            <p className="text-slate-400 mb-6">
              Ready to submit a load? Create an account or log in to access the full portal.
            </p>
            <div className="flex gap-4 justify-center">
              <Link to="/register">
                <Button className="bg-[#00A6E8] text-[#0A0E1A] font-bold uppercase tracking-wider hover:bg-[#33B8ED]">
                  Create Account
                  <ArrowRight className="ml-2" size={18} />
                </Button>
              </Link>
              <Link to="/login">
                <Button variant="outline" className="border-white/30 text-white font-bold uppercase tracking-wider hover:bg-white/5">
                  Client Login
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
}